<template>
    <ModalBase :name="name" title="Añadir nuevo campo" subtitle="Seleccione los campos que quiere añadir">
        <div v-if="availableFields.length > 0">
            <div class="tw:mb-4">
                <BaseMultiselect
                    v-model="selectedFields"
                    name="fields-select"
                    label="Campos"
                    :options="availableFields"
                    :multiple="true"
                    :loading="loading"
                    rules="required"
                    data-cy="selector-campos"
                />
            </div>
            <div v-if="isBases" class="tw:mb-4 tw:space-y-3">
                <div v-if="checkError" class="tw:text-xs tw:text-red-600 tw:font-medium tw:mb-2">
                    Debe seleccionar al menos un checkbox para continuar
                </div>
                <ToggleSwitch
                    v-model="checks.deportista"
                    data-cy="deportista"
                >
                    Deportista
                </ToggleSwitch>
                <ToggleSwitch
                    v-model="checks.representantes"
                    data-cy="responsables"
                >
                    Representantes
                </ToggleSwitch>
            </div>
        </div>
        <div v-else class="tw:py-4 tw:text-center tw:text-red-500">
            No hay campos disponibles para seleccionar
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="handleCancel">Cancelar</Button>
                <Button
                    :disabled="selectedFields.length === 0"
                    @click="handleSubmit"
                    data-cy="add-fields"
                >
                    Guardar
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, reactive, getCurrentInstance } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        name: {
            type: String,
            required: true
        },
        isBases: {
            type: Boolean,
            default: false
        },
        availableFields: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['add', 'close']);

    const { proxy } = getCurrentInstance();

    const selectedFields = ref([]);
    const checks = reactive({
        deportista: false,
        representantes: false
    });
    const checkError = ref(false);

    function resetState() {
        selectedFields.value = [];
        checks.deportista = false;
        checks.representantes = false;
        checkError.value = false;
    }

    function handleSubmit() {
        checkError.value = false;

        if (props.isBases) {
            if (!checks.deportista && !checks.representantes) {
                checkError.value = true;
                return;
            }

            const payload = selectedFields.value.map(id => ({
                id,
                deportista: checks.deportista ? 1 : 0,
                representante: checks.representantes ? 1 : 0
            }));
            emit('add', payload);
        } else {
            emit('add', selectedFields.value);
        }

        closeModal();
        resetState();
    }

    function handleCancel() {
        closeModal();
        resetState();
    }

    function closeModal() {
        proxy.$modal.hide(props.name);
        emit('close');
    }
</script>
